import { resolveApiUrl } from "@simpro/api-client";
import { env } from "./env";

/** An API-rooted image or file address made absolute for this build's API origin (ADR-0008). */
export function apiUrl(address: string): string {
  return resolveApiUrl(env.apiBaseUrl, address);
}
